import React from 'react';
import { checkIfDictionaryNotEmpty } from 'utils/validator.js';
import logger from 'logger/logHelper';
class NativeJSInterface {
    constructor () {
        this.jsInterface = window.ZTAndroid;
        this.logout = this.logout;
        this.assignmentStatusChange = this.assignmentStatusChange;
    }

    /**
     * Handles the clearing of the local cache in the Native App, if exists
     */
    logout () {
        if (!checkIfDictionaryNotEmpty(this.jsInterface)) {
            logger.logError(`Expected Native JS Interface, found ${this.jsInterface}`);
            return false;
        }
        this.jsInterface.logout();
        return true;
    }

    /**
     * Handles the assignment (visit) status change in the Native App by calling the
     * assignment status change API from the native app itself. We have used
     * this workflow since we get better location coordinates from the native
     * app itself
     * @param {Object} assignmentObject 
     * @param {Boolean} isOffline 
     */
    assignmentStatusChange(assignmentObject, isOffline) {
        if (!checkIfDictionaryNotEmpty(this.jsInterface)) {
            logger.logError(`Expected Native JS Interface, found ${this.jsInterface}`);
            return false;
        }
        const updateAssignmentProps = {
            ...assignmentObject,
            isOfflineJob: isOffline
        }
        this.jsInterface.onVisitStatusChange(JSON.stringify(updateAssignmentProps));
        return true;
    }

    /**
     * Returns true when the PWA is running inside the Android WebView native app
     */
    isAndroid() {
        return !!this.jsInterface;
    }

    /**
     * Returns the Android app version string from the native layer.
     * Returns null when not running inside the Android app.
     */
    getAppVersion() {
        if (!this.jsInterface) return null;
        try {
            return this.jsInterface.getAppVersion() || null;
        } catch (e) {
            logger.logError(`NativeJSInterface.getAppVersion error: ${e}`);
            return null;
        }
    }

    /**
     * Returns a device info string (manufacturer, model, OS version) from the native layer.
     * Returns null when not running inside the Android app.
     */
    getDeviceInfo() {
        if (!this.jsInterface) return null;
        try {
            return this.jsInterface.getDeviceInfo() || null;
        } catch (e) {
            logger.logError(`NativeJSInterface.getDeviceInfo error: ${e}`);
            return null;
        }
    }
}

export default NativeJSInterface;